import { Link } from 'react-router-dom';

import { Avatar, Box } from '@mui/material';

import dayjs from 'dayjs';
import { MRT_ColumnDef } from 'material-react-table';

import { VennueAccessRequestItem } from '../../../../graphql/API';
import LinkProfile from '../../../../pages/Collabs/components/LinkProfile';
import Icons from '../../../../themes/icons';
import StatusLabel from '../../../StatusLabel/StatusLabel';

export const productRequestsTableColumns = (): MRT_ColumnDef<VennueAccessRequestItem>[] => [
  {
    accessorKey: 'user.picture.thumbnail',
    header: '',
    size: 20,
    enableSorting: false,
    Cell: ({ row }) => (
      <Avatar
        src={String(row.original.user?.picture?.thumbnail)}
        alt={row.original.user?.firstname || ''}
        sx={{ height: '40px', width: '40px' }}
      />
    ),
  },
  {
    accessorKey: 'userName',
    header: 'User',
    size: 200,
    enableSorting: true,
    Cell: ({
      row: {
        original: { user, userID, offer },
      },
    }) => (
      <Box display={'flex'} alignItems={'center'} gap='6px'>
        <LinkProfile
          fontSize='15px'
          url={`/users/${userID}`}
          label={`${user?.firstname} ${user?.lastname}`}
          hoverTextDecoration='underline'
        />
        {offer?.incentiveValue ? <Icons.DollarSignV2Icon /> : null}
      </Box>
    ),
  },
  {
    accessorKey: 'offerTitle',
    header: 'Product',
    size: 200,
    Cell: ({ row }) => (
      <Box
        component={Link}
        sx={{
          color: '#111',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
        }}
        to={`/offers/${row.original.offerID}`}
      >
        {row.original.offer?.title}
      </Box>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: 'Date',
    size: 120,
    Cell: ({ row }) => dayjs.utc(row.original.createdAt).format('ll'),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 180,
    muiTableHeadCellProps: {
      align: 'center',
    },
    muiTableBodyCellProps: {
      align: 'center',
    },
    muiTableFooterCellProps: {
      align: 'center',
    },
    Cell: ({ row }) => (
      <StatusLabel type='accessRequestStatus' status={row.original.status} emptyBackground />
    ),
  },
];
